import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import { useParams } from 'react-router-dom';

interface QueryData {
  url: string;
  cartId: string;
  periodId: string;
  groupId: string;
  catalogId: string;
  cartName: string;
  regenerateFlow: boolean;
  proposalType: 'SHELF' | 'RFQ';
}

/**
 * Returns a parametrized string for the proposal-related pages in a format: {periodId}?cartId=${cartId}&groupId=${groupId}&catalogId=${catalogId}&cartName=${cartName};
 * Should be inserted in a route like: /proposal/{insert_this_value}
 */
export function useProposalUrlParams(): QueryData {
  const query = useQueryParams();
  const { periodId } = useParams<{ periodId: string }>();

  if (!periodId) {
    throw new Error('No period in proposal url!');
  }

  const cartId = query.get('cartId') || '';
  const groupId = query.get('groupId') || '';
  const catalogId = query.get('catalogId') || '';
  const cartName = query.get('cartName') || '';
  const regenerateFlow = query.get('regenerateFlow');
  const proposalType = query.get('proposalType') as 'SHELF' | 'RFQ';

  return {
    url: `${periodId}?cartId=${cartId}&groupId=${groupId}&catalogId=${catalogId}&cartName=${cartName}`,
    cartId,
    periodId,
    groupId,
    catalogId,
    cartName,
    regenerateFlow: !!regenerateFlow,
    proposalType,
  };
}
